import React from 'react';
import { reviews, shopInfo } from '../mock';
import { Star, Quote } from 'lucide-react';
import { Button } from './ui/button';

const Reviews = () => {
  return (
    <section id="reviews" className="relative bg-[#0f0d0a] py-28 md:py-36 border-y border-[#c9a961]/10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="reveal grid lg:grid-cols-3 gap-10 items-end mb-14">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-[#c9a961]" />
              <span className="text-[#c9a961] tracking-[0.35em] text-xs uppercase">Avis clients</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#f5efe4] leading-tight">
              Une adresse <em className="text-[#c9a961]">appréciée</em> à Toulouse.
            </h2>
          </div>
          <div className="bg-[#141110] border border-[#c9a961]/25 p-6 text-center">
            <div className="font-display text-6xl text-[#c9a961] leading-none">
              {shopInfo.rating}
            </div>
            <div className="flex items-center justify-center gap-1 mt-2 text-[#c9a961]">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#c9a961]" />
              ))}
            </div>
            <div className="text-xs uppercase tracking-widest text-[#a8a29e] mt-2">
              {shopInfo.reviewsCount} avis du web
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r) => (
            <div
              key={r.id}
              className="reveal relative bg-[#141110] border border-[#c9a961]/10 p-7 hover:border-[#c9a961]/50 transition-colors"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#c9a961]/20" />
              <div className="flex items-center gap-1 text-[#c9a961]">
                {Array.from({ length: r.rating }).map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 fill-[#c9a961]" />
                ))}
              </div>
              <p className="mt-5 text-[#c8beab] leading-relaxed text-[15px]">
                « {r.text} »
              </p>
              <div className="mt-6 pt-5 border-t border-[#c9a961]/10 flex items-center justify-between">
                <div className="font-display text-lg text-[#f5efe4]">{r.author}</div>
                <div className="text-xs text-[#a8a29e]">{r.date}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="reveal text-center mt-14">
          <a
            href="https://www.google.com/search?q=JR+Barber+271+Route+de+Narbonne+31400+Toulouse+avis"
            target="_blank"
            rel="noreferrer"
          >
            <Button
              variant="outline"
              className="border-[#c9a961] text-[#c9a961] bg-transparent hover:bg-[#c9a961] hover:text-[#0a0a0a] rounded-none px-8 py-6"
            >
              Voir tous les avis Google
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
